function LoadingScreen() {
    return (
        <div className="loading-screen">
            <img src={require("../../../App/animation.gif")} alt="Loading..." className="loading-screen__image" />
        </div>
    )
}

export default LoadingScreen
